var formsFunctions = (function ($) {
    var initSelect2 = function () {
        // Check if function exists
        if ($.isFunction($(window).select2)) {
            if ($('select') !== undefined && $('select').length > 0) {
                $('select').each(function () {
                    if (!$(this).is("[multiple]")) {
                        var _datalabel = $(this).data("default");
                        if (_datalabel === undefined || _datalabel === "") {
                            _datalabel = "Please select";
                        }

                        $(this).select2({
                            theme: 'bootstrap4',
                            placeholder: _datalabel,
                            minimumResultsForSearch: 15,
                            templateSelection: formatEligibleResult,
                            templateResult: formatEligibleResult
                        });
                    }
                });

                $("select").on("select2:close", function (e) {
                    $(this).valid();
                });

                if ($(".select2-atleast-one").length) {
                    $("select").each(function () {
                        $(this).on('select2:select', function (e) {
                            $(".select2-atleast-one-val").removeAttr("disabled");
                        });
                    });
                }
            }
        }
    };

    var formatEligibleResult = function (res) {
        var hasDataEligible = $(res.element).data("eligible");
        var hasDataEligibleText = $(res.element).data("eligible-text");

        if (hasDataEligible === undefined || hasDataEligible === "") {
            return res.text;
        }
        else {
            var $res = $(
                '<div class="d-flex align-items-center justify-content-between">' +
                '<span>' + res.text + '</span>' +
                '<span class="border p-1 border-qualification-eligible border-qualification-eligible-' + hasDataEligible.toLowerCase() + '">' + hasDataEligibleText + '</span>' +
                '</div>'
            );

            return $res;
        }
    }

    var initTrumbowyg = function () {
        // check if function exists
        if ($.isFunction($(window).trumbowyg)) {
            $.trumbowyg.svgPath = '/Images/trumbowyg-icons.svg';

            if ($("textarea[data-mode='custom']").length) {
                $("textarea[data-mode='custom']").each(function () {
                    // More info: https://alex-d.github.io/Trumbowyg/documentation/#get-started
                    $(this).trumbowyg({
                        btns: [
                            ['formatting'],
                            ['strong', 'em'],
                            ['unorderedList', 'orderedList'],
                            ['link'],
                            ['removeformat'],
                        ],
                        minimalLinks: true,
                        urlProtocol: true
                    });
                });
            }
        }
        else {
            console.warn("Trumbowyg: Plugin not loaded");
        }
    };

    var togglePasswordInput = function () {
        if ($(".input-password-btn").length) {
            $($(".input-password-btn").click(function () {
                var inputParent = $(this).parent().parent().find(".input-password");
                var iconBtn = $(this).find(".icon");
                var iconTxt = $(this).find(".text");

                if ($(inputParent).length) {
                    if ($(inputParent).attr("type") === "password") {
                        $(inputParent).attr('type', 'text');

                        if (iconBtn !== undefined) {
                            $(iconBtn).removeClass('fa fa-eye-slash').addClass('fa fa-eye');
                        }

                        if (iconTxt !== undefined && umbracoJSResources !== undefined) {
                            $(iconTxt).text(umbracoJSResources["HidePassword"]);
                        }
                    }
                    else {
                        $(inputParent).attr('type', 'password');
                        if (iconBtn !== undefined) {
                            $(iconBtn).removeClass('fa fa-eye').addClass('fa fa-eye-slash');
                        }

                        if (iconTxt !== undefined && umbracoJSResources !== undefined) {
                            $(iconTxt).text(umbracoJSResources["ShowPassword"]);
                        }
                    }
                }
            }));
        }
    }

    var toggleAddressForm = function () {
        if ($(".searchAddress-manualbtn").length) {
            $(".searchAddress-manualbtn").click(function () {
                $("input.form-control").each(function () {
                    $(this).attr("readonly", false);
                    $(this).val("");
                });
                $("select.form-control").each(function () {
                    $(this).attr("disabled", false);

                    if ($(this).hasClass("select2-hidden-accessible")) {
                        $(this).val("");
                        $(this).trigger('change.select2');
                    }
                });

                if ($(".address-editbtn").is(":visible")) {
                    $(".address-editbtn").toggle();
                }
                $("#HomeAddressForReview").val("True");
            });
        }
    }

    var toggleAddressEditForm = function () {
        if ($(".address-editbtn").length) {
            $(".address-editbtn").click(function () {
                $("input.form-control").each(function () {
                    if (this.id != "OptionalPostCode") {
                        $(this).attr("readonly", false);
                    }
                });
                $("select.form-control").each(function () {
                    $(this).attr("disabled", false);
                });
                $(this).toggle();
            });
        }
    }

    var toggleWorkAddressEditForm = function () {
        if ($(".workaddress-editbtn").length) {
            $(".workaddress-editbtn").click(function () {
                $(".address-lookup-group").toggle();

                if (window.TrilliumFormHelpers !== undefined) {
                    TrilliumFormHelpers.scrollToTopSubmittedForm(
                        ".address-lookup-group"
                    );
                }

                $(this).toggle();
            });
        }
    }

    var addressFormValidation = function () {
        if ($(".btn-address-validation").length) {
            $(".btn-address-validation").click(function () {
                $(".form-group.has-error").each(function () {
                    $(this).find("input.form-control").each(function () { $(this).attr("readonly", false); });
                    $(this).find("select.form-control").each(function () { $(this).attr("disabled", false); });
                });
            });
        }
    }

    var toggleEditableDetailsForm = function () {
        unbindToggleEditableDetailsForm();

        if ($(".btn-edit-details").length) {
            $(".btn-edit-details").click(function () {
                var parentForm = $(this).closest("form");
                parentForm.find("input.form-control").each(function () {
                    $(this).attr("readonly", false);
                    // save old value
                    $(this).data("prev-val", $(this).val());
                });

                parentForm.find("input.form-check-input").each(function () {
                    $(this).attr("disabled", false);
                    // save old value
                    $(this).attr("data-prev-val", $(this).is(":checked"));
                });

                parentForm.find(".btn-save-details").each(function () {
                    $(this).toggle();
                });

                parentForm.find(".div-cancel-details").each(function(){
                    $(this).toggle();
                });

                parentForm.find(".btn-cancel-details").each(function () {
                    $(this).toggle();
                });

                parentForm.find(".btn-edit-details").each(function () {
                    $(this).toggle();
                });
            });
        }

        if ($(".btn-cancel-details").length) {
            $(".btn-cancel-details").click(function () {
                var parentForm = $(this).closest("form");
                parentForm.find("input.form-control").each(function () {
                    $(this).attr("readonly", true);
                    // restore old value
                    $(this).val($(this).data("prev-val"));
                });

                parentForm.find("input.form-check-input").each(function () {
                    $(this).attr("disabled", true);
                    // restore old value
                    $(this).prop("checked", $(this).data("prev-val"));
                });

                parentForm.find(".btn-save-details").each(function () {
                    $(this).toggle();
                });

                parentForm.find(".div-cancel-details").each(function(){
                    $(this).toggle();
                });

                parentForm.find(".btn-cancel-details").each(function () {
                    $(this).toggle();
                });

                parentForm.find(".btn-edit-details").each(function () {
                    $(this).toggle();
                });
            });
        }
    }

    var togglePasswordForm = function () {
        if ($(".btn-edit-password").length) {
            $(".btn-edit-password").click(function () {
                var placeholderContainer = $(this).closest(".password-placeholder-form");
                var formContainer = placeholderContainer.next(".password-edit-form");

                placeholderContainer.toggle();
                formContainer.toggle();
            });
        }

        if ($(".btn-cancel-password").length) {
            $(".btn-cancel-password").click(function () {
                var placeholderContainer = $(this).closest(".password-edit-form");
                var formContainer = placeholderContainer.parent().find(".password-placeholder-form");

                // Clear the values in the form
                placeholderContainer.find("input").val("");
                placeholderContainer.toggle();
                formContainer.toggle();
            });
        }
    };

    var toggleEditDirectDebitForm = function () {
        if ($(".btn-edit-direct-debit").length) {
            $(".btn-edit-direct-debit").click(function () {
                $(".view-direct-debit").toggle();
                $(".edit-direct-debit").toggle();
            })
        }
    }

    var handlePaymentMethodChange = function () {
        // When a payment method is changed on the subscription form, trigger a form reload to add/remove
        // the direct debit discount.
        if ($("input[type=radio][name=PaymentMethodId]").length) {
            $("input[type=radio][name=PaymentMethodId]").change(function () {
                var parentForm = $(this).closest("form");
                parentForm.find("input[name=UpdateTotal]").first().val("true");
                parentForm.submit();
            })
        }
    }

    var paginateJournalSubscriptions = function () {
        if ($(".journalPage").length != 0) {
            numberOfPages = $(".journalPage").length;

            if (typeof nextLabel == 'undefined') {
                var nextLabel = "Next";
            }

            if (typeof previousLabel == 'undefined') {
                var previousLabel = "Previous";
            }

            if (numberOfPages != 1) {
                $('.journalPagination').append('<li class="page-item page-item-previous page-previous disabled mr-20 fa-lg">' +
                    '<a href="#" class="page-link previousJournal">' +
                    '<i class="fas fa-long-arrow-alt-left mr-10"></i>' +
                    '<span class="paginationNavsText">' + previousLabel + '</span></a ></li > ');

                for (i = 0; i < numberOfPages; i++) {
                    var pageNum = i + 1;
                    var firstChild = "";
                    var lastChild = "";

                    if (i == 0) {
                        firstChild = "first-child"
                    }
                    if (i == (numberOfPages - 1)) {
                        lastChild = "last-child";
                    }

                    $('.journalPagination').append('<li class="page-item page-journal ' + firstChild + ' ' + lastChild + '" rel="' + i + '">' +
                        '<a href="#" class="page-link" rel="' + i + '">' + pageNum + '</a></li>');
                }

                $('.journalPagination').append('<li class="page-item page-item-next page-next ml-20 fa-lg">' +
                    '<a href="#" class="page-link nextJournal">' +
                    '<span class="paginationNavsText">' + nextLabel + '</span>' +
                    '<i class="fas fa-long-arrow-alt-right ml-10"></i></a></li>');

                $('.journalPage').hide();
                $('.journalPage').slice(0, 1).show();

                $('.page-journal a:first').addClass('active');
                $('.page-journal a:first').parent().addClass('active');
                $('.journalPagination a').bind('click', function (e) {
                    e.preventDefault();
                    var currPage = 0;

                    if ($(this).hasClass("previousJournal")) {
                        // Gets current active page
                        var currActive = $('.journalPagination a.active').attr("rel");

                        // Reduce by 1
                        currPage = (parseInt(currActive) - 1);

                        // If has previous page to the active one
                        if (currPage > 1) {
                            var prevActive = (parseInt(currPage) - 1);
                        }

                        // Disable the Previous button if currPage is the first one
                        if (currPage == 0) {
                            $(".page-previous").addClass("disabled");
                        }

                        // Enable Next Button
                        $(".page-next").removeClass("disabled");

                        // Clear the itens that have both active-sibling and active classes
                        $('.page-journal').removeClass('active-sibling');
                        $('.journalPagination a').removeClass('active-sibling');

                        $('.page-journal').removeClass('active');
                        $('.journalPagination a').removeClass('active');

                        // If the new current page is not 0 (first one) set the previous with class "active-sibling"
                        if (currPage != 0) {
                            $('.journalPagination a[rel=' + prevActive + ']').addClass('active-sibling');
                            $('.journalPagination a[rel=' + prevActive + ']').parent().addClass('active-sibling');
                        }

                        // Set the current page to active
                        $('.journalPagination a[rel=' + currPage + ']').addClass('active');
                        $('.journalPagination a[rel=' + currPage + ']').parent().addClass('active');
                    }
                    else if ($(this).hasClass("nextJournal")) {
                        // Gets current active page
                        var currActive = $('.journalPagination a.active').attr("rel");

                        // Set it as previous active page
                        var prevActive = currActive;

                        // Increment by 1
                        currPage = (parseInt(currActive) + 1);

                        // Disable the Next button if currPage is the last one
                        if (currPage == (numberOfPages - 1)) {
                            $(".page-next").addClass("disabled");
                        }

                        // Enable Previous Button
                        $(".page-previous").removeClass("disabled");

                        // Clear the itens that have both active-sibling and active classes
                        $('.page-journal').removeClass('active-sibling');
                        $('.journalPagination a').removeClass('active-sibling');

                        $('.page-journal').removeClass('active');
                        $('.journalPagination a').removeClass('active');

                        // Set the previous to the current with class "active-sibling"
                        $('.journalPagination a[rel=' + prevActive + ']').addClass('active-sibling');
                        $('.journalPagination a[rel=' + prevActive + ']').parent().addClass('active-sibling');

                        // Set the current page to active
                        $('.journalPagination a[rel=' + currPage + ']').addClass('active');
                        $('.journalPagination a[rel=' + currPage + ']').parent().addClass('active');
                    }
                    else {
                        // Gets current active page
                        currPage = $(this).attr('rel');

                        // If has previous page to the active one
                        if (currPage > 1) {
                            var prevActive = (parseInt(currPage) - 1);
                        }

                        $(".page-next").removeClass("disabled");
                        $(".page-previous").removeClass("disabled");

                        // Disable the Previous button and enable Next button if currPage is the first one
                        if (currPage == 0) {
                            $(".page-previous").addClass("disabled");
                            $(".page-next").removeClass("disabled");
                        }

                        // Disable the Next button if currPage is the last one
                        if (currPage == (numberOfPages - 1)) {
                            $(".page-previous").removeClass("disabled");
                            $(".page-next").addClass("disabled");
                        }

                        // Clear the itens that have both active-sibling and active classes
                        $('.page-journal').removeClass('active-sibling');
                        $('.journalPagination a').removeClass('active-sibling');

                        $('.page-journal').removeClass('active');
                        $('.journalPagination a').removeClass('active');

                        // If the new current page is not 0 (first one) set the previous with class "active-sibling"
                        if (currPage != 0) {
                            $('.journalPagination a[rel=' + prevActive + ']').addClass('active-sibling');
                            $('.journalPagination a[rel=' + prevActive + ']').parent().addClass('active-sibling');
                        }

                        $(this).addClass('active');
                        $(this).parent().addClass('active');
                    }

                    var startItem = currPage * 1;
                    var endItem = startItem + 1;
                    $('.journalPage').css('opacity', '0').hide().slice(startItem, endItem).
                        css('display', 'flex').animate({
                            opacity: 1
                        }, 300);
                });
            }
        }
    }

    var journalAccordionCollapseParentEffect = function () {
        if ($(".subscription-card").length > 0) {
            $(".subscription-card--about--action--link").on("click", function () {
                if ($(this).hasClass("collapsed")) {
                    $(this).parent().parent().parent().addClass("hoverEffect");
                }
                else {
                    $(this).parent().parent().parent().removeClass("hoverEffect");
                }
            });
        }
    }

    var productCategoriesFormFurtherDetailsToggle = function () {
        if ($(".reducedRateForm").length > 0) {
            if ($(".ReducedRateFormField").length > 0) {
                $('.ReducedRateFormField').on('select2:select', function (e) {
                    var data = e.params.data;
                    var textVal = data.text;
                    if (textVal.toLowerCase() === "other") {
                        $(".furtherReason").removeClass("d-none");
                    }
                    else {
                        if (!$(".furtherReason").hasClass("d-none")) {
                            $(".furtherReason").addClass("d-none");
                        }
                    }
                });
            }
        }
    }

    var bindInputSpinner = function () {
        $(".inputSpinner").inputSpinner(
            {
                buttonsClass: "btn btn-primary",
                template: // the template of the input
                    '<div class="input-group ${groupClass}">' +
                    '<div class="d-inline-block"><button style="min-width: ${buttonsWidth}" class="btn fakeSquare btn-decrement ${buttonsClass} btn-minus" type="button">${decrementButton}</button></div>' +
                    '<input type="text" inputmode="decimal" style="text-align: ${textAlign}" class="form-control fakeRect form-control-text-input d-inline-block mlr-20"/>' +
                    '<div class="d-inline-block"><button style="min-width: ${buttonsWidth}" class="btn fakeSquare btn-increment ${buttonsClass} btn-plus" type="button">${incrementButton}</button></div>' +
                    '</div>'
            });
    }

    //var TextAreaMaxLength = function () {
    //        $("textarea[maxlength]").bind('input propertychange', function () {
    //            var maxLength = $(this).attr('maxlength');
    //            //I'm guessing JavaScript is treating a newline as one character rather than two so when I try to insert a "max length" string into the database I get an error.
    //            //Detect how many newlines are in the textarea, then be sure to count them twice as part of the length of the input.
    //            var newlines = ($(this).val().match(/\n/g) || []).length
    //            if ($(this).val().length + newlines > maxLength) {
    //                $(this).val($(this).val().substring(0, maxLength - newlines));
    //            }
    //        })

    //}

    var EB_MinMax_Sessions = function () {
        //$('#PreferencesLandingWrapper').on("click", ".check_all", function () {
        //    var parent = $(this).closest('.checkAllWrapper');
        //    parent.find('input[type="checkbox"]').prop('checked', this.checked);
        //});

        //$('#PreferencesLandingWrapper').on("click", ".preferenceOption", function () {
        //    var parent = $(this).closest('.checkAllWrapper');
        //    if (!this.checked) {
        //        parent.find('.check_all').prop("checked", this.checked);
        //    }
        //    else {
        //        var all_checkboxes = parent.find('.preferenceOption');
        //        if (all_checkboxes.length === all_checkboxes.filter(":checked").length) {
        //            parent.find('.check_all').prop("checked", true);
        //        }
        //    };
        //});

        $('#event-booking-form').on("click", ".eb_session", function () {
            var parent = $(this).parents('.limitWrapper');
            if (parent.length > 0) {
                var max = $("#EditDelegate_MaxSessions").attr("value");
                var min = $("#EditDelegate_MinSessions").attr("value");

                var all_checkboxes = parent.find('.eb_session');
                if (max != null && max != undefined && max > 0) {
                    if (!this.checked) {
                        if (all_checkboxes.filter(":checked").length < max) {
                            parent.find('input.notMandatory[type="checkbox"]').removeAttr("disabled");
                        }
                        if (all_checkboxes.filter(":checked").length >= max) {
                            var $this = $(this);
                            $this.attr("disabled", true);
                        }
                    }
                    else {
                        if (all_checkboxes.filter(":checked").length >= max) {
                            parent.find('input[type="checkbox"]:not(:checked)').attr("disabled", true);
                        }
                    }
                }

                if (min != null && min != undefined) {
                    all_checkboxes = parent.find('.eb_session');
                    if (all_checkboxes.filter(":checked").length >= min) {
                        $(".SessionError").addClass("d-none");
                        $("#editDelegateSubmit").removeAttr("disabled");
                    }
                    else {
                        $(".SessionError").removeClass("d-none");
                        $("#editDelegateSubmit").attr("disabled", true);
                    }
                }
            }
        });
    };

    var dualMultiSelectForm = function () {
        if ($(".multiselect-group").length > 0) {
            $(".buttons-source .move").on("click", function () {
                if ($(".form-multiselect.source").val().length > 0) {
                    $(".form-multiselect.source > option:selected").each(function () {
                        if ($(".form-multiselect.target > option").length < 2) {
                            $(".form-multiselect.target").append(new Option($(this).text(), $(this).val()));
                            $(this).attr("disabled");
                            $(this).hide();
                        }
                        else {
                            return false;
                        }
                    });

                    multiselectUpdateHiddenField($(this).closest(".multiselect-group"));
                }
            });

            $(".buttons-target .remove").on("click", function () {
                if ($(".form-multiselect.target").val().length > 0) {
                    $(".form-multiselect.target > option:selected").each(function () {
                        $(".form-multiselect.source > option[value='" + $(this).val() + "']").removeAttr("disabled").show();
                        $(this).remove();
                    });
                }

                multiselectUpdateHiddenField($(this).closest(".multiselect-group"));
            });

            $(".buttons-target .up").on("click", function () {
                if ($(".form-multiselect.target").val().length == 1) {
                    $(".form-multiselect.target option:selected").insertBefore($(".form-multiselect.target option:selected").prev());
                    multiselectUpdateHiddenField($(this).closest(".multiselect-group"));
                }
            });

            $(".buttons-target .down").on("click", function () {
                if ($(".form-multiselect.target").val().length == 1) {
                    $(".form-multiselect.target option:selected").insertAfter($(".form-multiselect.target option:selected").next());
                    multiselectUpdateHiddenField($(this).closest(".multiselect-group"));
                }
            });

            var multiselectUpdateHiddenField = function (target) {
                var input = $(target).find('.multiselect-selectedValues');
                var selectedOps = $(target).find('.form-multiselect.target option');
                var selectedOpsStr = "";

                $(selectedOps).each(function () {
                    if (selectedOpsStr != "") {
                        selectedOpsStr += ";"
                    }

                    selectedOpsStr += $(this).val();
                });

                $(input).val(selectedOpsStr);
            }
        }
    }

    var hideOnlinePaymentHeader = function () {
        if ($(".onlinePayment").length > 0) {
            if ($(".onlinePayment").val() === "true") {
                $(".listed-option-header").hide();
            }
        }
    }

    var selectAllChildrenCheckbox = function () {
        if ($('input[type="checkbox"]').length > 0) {
            $('input[type="checkbox"]').on("click", function () {
                var id = $(this).attr("id");
                var rowChildren = "#collapse-" + id;
                var currDataLevel = $(this).closest("[data-level]").data("level");

                if ($(this).is(":checked")) {
                    if ($(rowChildren).length > 0) {
                        $(rowChildren).children().find('input[type="checkbox"]').prop("checked", true);
                    }
                }
                else {
                    if ($(rowChildren).length > 0) {
                        $(rowChildren).children().find('input[type="checkbox"]').prop("checked", false);
                    }
                }

                if (currDataLevel > 1) {
                    var total = $(this).closest("[data-level]").find("input[type='checkbox']").length;
                    var totalChecked = $(this).closest("[data-level]").find("input[type='checkbox']:checked").length;

                    if (total == totalChecked) {
                        $(this).parent().parent().parent().parent().parent().parent().find("input[type='checkbox']").first().prop("checked", true);
                    }
                }
            });
        }
    }

    var selectParentCheckbox = function selectParentCheckbox() {
        if ($('input[type="checkbox"]').length > 0) {
            $('input[type="checkbox"]').on("click", function () {
                var id = $(this).attr("id");
                var preferenceId = id.replace("Preference-", "");
                var parentId = $(`#parent-${preferenceId}`).val();
                var totalChecked = $(this).closest("[data-level]").find("input[type='checkbox']:checked").length;

                var toplevel = $(`#parent-${parentId}`).val();
                if (this.checked) {
                    $(`#Preference-${parentId}`).prop("checked", this.checked);

                    $(`#Preference-${toplevel}`).prop("checked", this.checked);
                } else if (totalChecked == 0) {
                    $(`#Preference-${parentId}`).prop("checked", this.checked);
                    var topleveltotalChecked = $(`#Preference-${toplevel}`).closest("[data-level]").find("input[type='checkbox']:checked").length;
                    if (topleveltotalChecked <= 1) {
                        $(`#Preference-${toplevel}`).prop("checked", this.checked);
                    }
                }
            });
        }
    }

    var showFormLoadingState = function () {
        $(".show-loading-state-link").on("click", function () {
            TrilliumLoadingComponent.showFullScreenLoading();
        });

        $(".show-loading-state-form").submit(function () {
            if ($(this).valid()) {
                TrilliumLoadingComponent.showFullScreenLoading();
            }
        });
    }

    var triggerHiddenButton = function () {
        if ($(".triggerAction").length > 0) {
            $(".triggerAction").on("click", function () {
                $(".triggerHidden").click();
            });
        }
    }

    var toggleWorkStatusOptions = function () {
        $(".switch-visibility-element-on-click").on("click", function () {
            var setVisibilitytargetVisible = $(this).data("set-visibility-target-visible");
            var setVisibilitytargetInVisible = $(this).data("set-visibility-target-invisible");

            var removefieldreadonly = $(this).data("remove-field-readonly");
            var setfieldreadonly = $(this).data("set-field-readonly");

            if (removefieldreadonly !== null && removefieldreadonly !== undefined) {
                $(removefieldreadonly).each(function () {
                    $(this).prop('disabled', false);
                });
            }

            if (setfieldreadonly !== null && setfieldreadonly !== undefined) {
                $(setfieldreadonly).each(function () {
                    $(this).prop('disabled', true);
                });
            }

            if (setVisibilitytargetVisible !== null && setVisibilitytargetVisible !== undefined && setVisibilitytargetInVisible !== null && setVisibilitytargetInVisible !== undefined) {
                var tempBtn = $(".tempBtn");
                var targetElemVisible = $(setVisibilitytargetVisible);
                var targetElemInVisible = $(setVisibilitytargetInVisible);

                if (!tempBtn.hasClass('d-none')) {
                    tempBtn.addClass('d-none');
                }

                if (targetElemVisible.hasClass('d-none')) {
                    targetElemVisible.removeClass('d-none');
                }
                if (!targetElemInVisible.hasClass('d-none')) {
                    targetElemInVisible.addClass('d-none');
                }
            }
        });
    };

    var toggleVisibleOnDropdown = function () {
        $(".set-visibility-element-on-change").on("change", function () {
            var optionSelected = $(this);
            var valueSelected = optionSelected.val();

            var setvisibilitytarget = $(this).data("set-visibility-target");
            var setfieldtarget = $(this).data("set-field-target");

            if (valueSelected === undefined || valueSelected == -1) {
                if (setfieldtarget !== null && setfieldtarget !== undefined) {
                    $(setfieldtarget).each(function () {
                        $(this).prop('disabled', true);
                    });
                }

                if (setvisibilitytarget !== null && setvisibilitytarget !== undefined) {
                    var targetElemToHide = $(setvisibilitytarget);
                    if (!targetElemToHide.hasClass('d-none')) {
                        targetElemToHide.addClass('d-none');
                    }
                }
            }
            else {
                if (setfieldtarget !== null && setfieldtarget !== undefined) {
                    $(setfieldtarget).each(function () {
                        $(this).prop('disabled', false);
                    });
                }

                if (setvisibilitytarget !== null && setvisibilitytarget !== undefined) {
                    var targetElemToShow = $(setvisibilitytarget);
                    if (targetElemToShow.hasClass('d-none')) {
                        targetElemToShow.removeClass('d-none');
                    }
                }
            }
        });
    };

    var unbindToggleEditableDetailsForm = function () {
        if ($(".btn-edit-details").length) {
            $(".btn-edit-details").off("click")
        }

        if ($(".btn-cancel-details").length) {
            $(".btn-cancel-details").off("click")
        }
    }

    var fileUploadHelper = function () {
        if ($(".inputDnD").length > 0) {
            $(".inputDnD").each(function () {
                var _target = $(this).find(".control");
                var _targetInput = $(this).find(".inputDnD-input");
                var _targetSubmit = $(this).find(".btn-primary");

                if (_target.length > 0 && _targetInput.length > 0) {
                    console.info("Enabling file input");

                    var _targetLabel = _target.find(".inputDnD-label");
                    var _title = _targetInput.data("title");

                    if (_targetLabel.length > 0) {
                        _targetLabel.text(_title);
                    }
                    else {
                        _target.append("<span class='inputDnD-label'>" + _title + "</span>");
                        _targetLabel = _target.find(".inputDnD-label");
                    }

                    _target.off("click");
                    _target.on("click", function () {
                        _targetInput.click();
                    });

                    _targetInput.on("change", function () {
                        if ($(this)[0].files && $(this)[0].files[0]) {
                            let reader = new FileReader();
                            reader.onload = (e) => {
                                let imgData = e.target.result;
                                let imgName = $(this)[0].files[0].name;
                                $(this)[0].setAttribute("data-title", imgName);
                                _targetLabel.text(imgName);
                                _targetSubmit.removeAttr("disabled");
                            }
                            reader.readAsDataURL($(this)[0].files[0]);
                        }
                        else {
                            _targetSubmit.attr("disabled", true);
                        }
                    });
                }
                else {
                    console.warn("Element not found");
                }
            });
        }
    }

    var paginateContent = function () {
        if ($(".contentPage").length != 0) {
            numberOfPages = $(".contentPage").length;

            if (typeof nextLabel == 'undefined') {
                var nextLabel = "Next";
            }

            if (typeof previousLabel == 'undefined') {
                var previousLabel = "Previous";
            }

            if (numberOfPages != 1 && !$.trim($(".contentPagination").html())) {
                $('.contentPagination').append('<li class="page-item page-item-previous page-previous disabled mr-20 fa-lg">' +
                    '<a href="#" class="page-link previousPage">' +
                    '<i class="fas fa-long-arrow-alt-left mr-10"></i>' +
                    '<span class="paginationNavsText">' + previousLabel + '</span></a></li>');

                for (i = 0; i < numberOfPages; i++) {
                    var pageNum = i + 1;
                    var firstChild = "";
                    var lastChild = "";

                    if (i == 0) {
                        firstChild = "first-child"
                    }
                    if (i == (numberOfPages - 1)) {
                        lastChild = "last-child";
                    }

                    $('.contentPagination').append('<li class="page-item page-content ' + firstChild + ' ' + lastChild + '" rel="' + i + '"><a href="#" class="page-link" rel="' + i + '">' + pageNum + '</a></li>');
                }

                $('.contentPagination').append('<li class="page-item page-item-next page-next ml-20 fa-lg">' +
                    '<a href="#" class="page-link nextPage">' +
                    '<span class="paginationNavsText">' + nextLabel + '</span>' +
                    '<i class="fas fa-long-arrow-alt-right ml-10"></i></a></li>');

                $('.contentPage').hide();
                $('.contentPage').slice(0, 1).show();

                $('.page-content a:first').addClass('active');
                $('.page-content a:first').parent().addClass('active');
                $('.contentPagination a').bind('click', function (e) {
                    e.preventDefault();
                    var currPage = 0;

                    if ($(this).hasClass("previousPage")) {
                        // Gets current active page
                        var currActive = $('.contentPagination a.active').attr("rel");

                        // Reduce by 1
                        currPage = (parseInt(currActive) - 1);

                        // If has previous page to the active one
                        if (currPage > 1) {
                            var prevActive = (parseInt(currPage) - 1);
                        }

                        // Disable the Previous button if currPage is the first one
                        if (currPage == 0) {
                            $(".page-previous").addClass("disabled");
                        }

                        // Enable Next Button
                        $(".page-next").removeClass("disabled");

                        // Clear the itens that have both active-sibling and active classes
                        $('.page-content').removeClass('active-sibling');
                        $('.contentPagination a').removeClass('active-sibling');

                        $('.page-content').removeClass('active');
                        $('.contentPagination a').removeClass('active');

                        // If the new current page is not 0 (first one) set the previous with class "active-sibling"
                        if (currPage != 0) {
                            $('.contentPagination a[rel=' + prevActive + ']').addClass('active-sibling');
                            $('.contentPagination a[rel=' + prevActive + ']').parent().addClass('active-sibling');
                        }

                        // Set the current page to active
                        $('.contentPagination a[rel=' + currPage + ']').addClass('active');
                        $('.contentPagination a[rel=' + currPage + ']').parent().addClass('active');
                        if (window.TrilliumFormHelpers !== undefined) {
                            TrilliumFormHelpers.scrollToTopSubmittedForm(".list-group");
                        }
                    }
                    else if ($(this).hasClass("nextPage")) {
                        // Gets current active page
                        var currActive = $('.contentPagination a.active').attr("rel");

                        // Set it as previous active page
                        var prevActive = currActive;

                        // Increment by 1
                        currPage = (parseInt(currActive) + 1);

                        // Disable the Next button if currPage is the last one
                        if (currPage == (numberOfPages - 1)) {
                            $(".page-next").addClass("disabled");
                        }

                        // Enable Previous Button
                        $(".page-previous").removeClass("disabled");

                        // Clear the itens that have both active-sibling and active classes
                        $('.page-content').removeClass('active-sibling');
                        $('.contentPagination a').removeClass('active-sibling');

                        $('.page-content').removeClass('active');
                        $('.contentPagination a').removeClass('active');

                        // Set the previous to the current with class "active-sibling"
                        $('.contentPagination a[rel=' + prevActive + ']').addClass('active-sibling');
                        $('.contentPagination a[rel=' + prevActive + ']').parent().addClass('active-sibling');

                        // Set the current page to active
                        $('.contentPagination a[rel=' + currPage + ']').addClass('active');
                        $('.contentPagination a[rel=' + currPage + ']').parent().addClass('active');
                        if (window.TrilliumFormHelpers !== undefined) {
                            TrilliumFormHelpers.scrollToTopSubmittedForm(".list-group");
                        }
                    }
                    else {
                        // Gets current active page
                        currPage = $(this).attr('rel');

                        // If has previous page to the active one
                        if (currPage > 1) {
                            var prevActive = (parseInt(currPage) - 1);
                        }

                        $(".page-next").removeClass("disabled");
                        $(".page-previous").removeClass("disabled");

                        // Disable the Previous button and enable Next button if currPage is the first one
                        if (currPage == 0) {
                            $(".page-previous").addClass("disabled");
                            $(".page-next").removeClass("disabled");
                        }

                        // Disable the Next button if currPage is the last one
                        if (currPage == (numberOfPages - 1)) {
                            $(".page-previous").removeClass("disabled");
                            $(".page-next").addClass("disabled");
                        }

                        // Clear the itens that have both active-sibling and active classes
                        $('.page-content').removeClass('active-sibling');
                        $('.contentPagination a').removeClass('active-sibling');

                        $('.page-content').removeClass('active');
                        $('.contentPagination a').removeClass('active');

                        // If the new current page is not 0 (first one) set the previous with class "active-sibling"
                        if (currPage != 0) {
                            $('.contentPagination a[rel=' + prevActive + ']').addClass('active-sibling');
                            $('.contentPagination a[rel=' + prevActive + ']').parent().addClass('active-sibling');
                        }

                        $(this).addClass('active');
                        $(this).parent().addClass('active');
                        if (window.TrilliumFormHelpers !== undefined) {
                            TrilliumFormHelpers.scrollToTopSubmittedForm(".list-group");
                        }
                    }

                    var startItem = currPage * 1;
                    var endItem = startItem + 1;
                    $('.contentPage').css('opacity', '0').hide().slice(startItem, endItem).
                        css('display', 'block').animate({
                            opacity: 1
                        }, 300);

                    // scroll to top
                    if (window.TrilliumFormHelpers !== undefined) {
                        TrilliumFormHelpers.scrollToTopSubmittedForm("#" + "pagination-wrapper");
                    }
                });
            }
        }
    }

    var removeSelectedFromOthers = function () {
        if ($(".sponsorAttributeSel").length > 0) {
            $(".sponsorAttributeSel").on("select2:close", function (e) {
                var ddId = $(this).attr("id");
                var selValue = "";
                var allValues = [];

                if ($.isFunction($(window).select2)) {
                    selValue = $(this).select2("val");
                }
                else {
                    selValue = $(this).val();
                }

                // Re-enable the other previous disabled options
                $(".sponsorAttributeSel").each(function () {
                    $(this).find('option').removeAttr('disabled');
                    if ($(this).find('option').hasClass("d-none")) {
                        $(this).find('option').removeClass("d-none");
                    }
                });

                // Get all the selected values from all the dropdowns
                $(".sponsorAttributeSel").not("#" + ddId).each(function () {
                    if ($.isFunction($(window).select2)) {
                        allValues.push({ id: $(this).attr("id"), selected: $(this).select2("val") });
                    }
                    else {
                        allValues.push({ id: $(this).attr("id"), selected: $(this).val() });
                    }
                });

                $.each(allValues, function (index, value) {
                    $(".sponsorAttributeSel").not("#" + value.id).each(function () {
                        $(this).find('option[value="' + value.selected + '"]').attr('disabled', 'disabled');
                        $(this).find('option[value="' + value.selected + '"]').not("d-none").addClass("d-none");
                    });
                });

                // Disable selected option from the other dropdowns
                $(".sponsorAttributeSel").not("#" + ddId).each(function () {
                    $(this).find('option[value="' + selValue + '"]').attr('disabled', 'disabled');
                    $(this).find('option[value="' + selValue + '"]').not("d-none").addClass("d-none");
                });
            });
        }
    };

    var tooltipEnabled = function () {
        $(".tooltipEnabled").tooltip();
    }

    //var tempDataMessageHelper = function () {
    //    if ($(".fadeout-alert-message").length > 0) {
    //        setTimeout(function () {
    //            $(".fadeout-alert-message").fadeTo(2000, 500).fadeOut(1000, function () {
    //                $(".fadeout-alert-message").alert('close');
    //            });
    //        }, 4000);
    //    }

    //    if ($('.modal-alert-message').length > 0) {
    //        $('.modal-alert-message').modal('show');
    //    }
    //}

    // Functions avaiable
    return {
        start: function () {
            initSelect2();
            initTrumbowyg();
            togglePasswordInput();
            toggleAddressForm();
            toggleAddressEditForm();
            addressFormValidation();
            toggleEditableDetailsForm();
            toggleWorkAddressEditForm();
            togglePasswordForm();
            //handlePaymentMethodChange();
            toggleEditDirectDebitForm();
            paginateJournalSubscriptions();
            journalAccordionCollapseParentEffect();
            productCategoriesFormFurtherDetailsToggle();
            bindInputSpinner();
            dualMultiSelectForm();
            EB_MinMax_Sessions();
            hideOnlinePaymentHeader();
            selectAllChildrenCheckbox();
            selectParentCheckbox();
            showFormLoadingState();
            triggerHiddenButton();
            toggleWorkStatusOptions();
            toggleVisibleOnDropdown();
            fileUploadHelper();
            paginateContent();
            //TextAreaMaxLength();
            removeSelectedFromOthers();
            tooltipEnabled();
            //tempDataMessageHelper();
        },
        destroy: function () {
            unbindToggleEditableDetailsForm();
        },
        paginateContent: function () {
            paginateContent();
        }
    };
})(window.jQuery);

window.formsFunctions = formsFunctions;
formsFunctions.start();
